import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=3847c2ba&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"
import style0 from "./Album.vue?vue&type=style&index=0&id=3847c2ba&prod&scoped=true&lang=css"
import style1 from "./Album.vue?vue&type=style&index=1&id=3847c2ba&prod&lang=css"
import style2 from "./Album.vue?vue&type=style&index=2&id=3847c2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3847c2ba",
  null
  
)

export default component.exports